export function Trust() {
  const logos = [
    { name: "Aloa Agency", src: "/assets/customers/aloa agency.png" },
    { name: "AssetDash", src: "/assets/customers/assetdash.png" },
    { name: "Crypt", src: "/assets/customers/crypt.png" },
    { name: "Face26", src: "/assets/customers/face26.png" },
    { name: "KYC", src: "/assets/customers/kyc.png" },
    { name: "Morpher", src: "/assets/customers/morpher.png" },
    { name: "Seascape", src: "/assets/customers/seascape.png" },
    { name: "Stack3", src: "/assets/customers/stack3.png" },
    { name: "Storm Ideas", src: "/assets/customers/storm ideas.png" },
    { name: "SupportYourApp", src: "/assets/customers/supportyourapp.png" },
  ];
  // duplicate for seamless marquee
  const track = [...logos, ...logos];

  return (
    <section className="trust">
      <div className="container">
        <div className="trust-head">
          <span className="eyebrow"><span className="dot"></span>Selected clients · 2018, 2026</span>
          <p className="trust-line">From early-stage founders to public companies, twelve years of sitting at the table where the work gets made.</p>
        </div>
      </div>
      <div className="marquee">
        <div className="marquee-track">
          {track.map((l, i) => (
            <img key={i} src={l.src} alt={l.name} className="logo" />
          ))}
        </div>
      </div>
    </section>
  );
}
